import { createTheme, colors } from "@material-ui/core";
import shadows from "./shadows";
import typography from "./typography";

const theme = createTheme({
  palette: {
    // Matches tubayo.com: near-black accent on white surfaces.
    background: {
      default: "#F7F7F7",
      paper: colors.common.white,
    },
    primary: {
      contrastText: "#FFFFFF",
      main: "#222222",
      light: "#484848",
      dark: "#000000",
    },
    secondary: {
      contrastText: "#FFFFFF",
      main: "#0F172A", // Slate-900 — for dark surfaces / hero cards
      light: "#1E293B",
      dark: "#020617",
    },
    success: {
      main: "#10B981",
      light: "#ECFDF5",
      contrastText: "#FFFFFF",
    },
    warning: {
      main: "#F59E0B",
      light: "#FEF3C7",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#EF4444",
      light: "#FEF2F2",
      contrastText: "#FFFFFF",
    },
    info: {
      main: "#0EA5E9",
      light: "#F0F9FF",
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "#222222",
      secondary: "#717171",
      disabled: "#B0B0B0",
    },
    divider: "#EBEBEB",
  },
  shape: {
    borderRadius: 12,
  },
  shadows,
  typography,
  overrides: {
    MuiButton: {
      root: { borderRadius: 10, padding: "8px 18px" },
      containedPrimary: { boxShadow: "none", "&:hover": { boxShadow: "none" } },
    },
    MuiPaper: {
      rounded: { borderRadius: 16 },
      elevation1: { boxShadow: "none", border: "1px solid #EBEBEB" },
    },
    MuiCard: { root: { borderRadius: 16 } },
    MuiTableCell: {
      head: { color: "#717171", fontWeight: 600, fontSize: 12, textTransform: "uppercase", letterSpacing: "0.04em" },
    },
    MuiOutlinedInput: { root: { borderRadius: 10 } },
  },
});

export default theme;
